module.exports = __webpack_public_path__ + "static/media/close-default.b7ffe117.svg";